import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollTo from './utilities/scroll-to';

import initHideMenu from './components/hide-menu';
import initMenu from './components/menu';
import initSearch from './components/search';
import initCookies from './components/cookies';
import initEraSlider from './components/era-slider';
import initCaptcha from './components/captcha';
import initWordCounts from './components/word-count';
import initVideoPlays from './components/video-play';

initCookies();
initHideMenu();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuToggle = document.querySelector('.js-menu-button');
const searchToggle = document.querySelector('.js-search-button');

let menu = null;
let search = null;

if (menuToggle) {
    menu = initMenu(menuToggle, () => {
        if (search) {
            search.close();
        }
    });
}

if (searchToggle) {
    search = initSearch(searchToggle, () => {
        if (menu) {
            menu.close();
        }
    });
}

const scrollToEls = document.querySelectorAll('.js-scroll-to');

if (scrollToEls && scrollToEls.length > 0) {
    initScrollTo(scrollToEls);
}

const eraSlider = document.querySelector('.js-era-slider');

if (eraSlider) {
    initEraSlider(eraSlider);
}

const captchaEls = document.querySelectorAll('.js-recaptcha-form');

if (captchaEls && captchaEls.length > 0) {
    initCaptcha(captchaEls);
}

const wordCountEls = document.querySelectorAll('.js-word-count-el');

if (wordCountEls && wordCountEls.length > 0) {
    initWordCounts(wordCountEls);
}

const videoPlays = document.querySelectorAll('.js-media-play');

if (videoPlays && videoPlays.length > 0) {
    initVideoPlays(videoPlays);
}
